<script>
import Base from "@/components/RequestDetails/FundData.vue";

export default {
  name: "CustomerServiceFundData",
  extends: Base,
};
</script>

